import { CheckCircleIcon, ClipboardDocumentIcon } from "@heroicons/react/24/outline";
import clsx from "clsx";
import type { FunctionComponent, PropsWithChildren } from "react";

import Label from "~/components/formElements/Label";
import { useCopyStyled } from "~/hooks/useCopyStyled.ts";

type Props = PropsWithChildren & {
	label: string;
	theme?: "light" | "dark";
	enableCopyToClipboard?: boolean;
};

const CardValue: FunctionComponent<Props> = ({ children, label, theme = "light", enableCopyToClipboard = false }) => {
	const { copyToClipboard, copied, targetRef } = useCopyStyled({ includeFormatting: false });

	return (
		<div className="flex flex-col">
			<Label size="sm"
				   theme={theme}
				   lineHeight="none">
				{label}
			</Label>
			{enableCopyToClipboard ? (
				<div className="group relative">
					<div ref={targetRef} className="break-words">{children}</div>
					<button
						onClick={copyToClipboard}
						className="absolute inset-0 hidden items-center justify-center bg-white/50 group-hover:flex">
						<div
							className={clsx(
								"flex items-center justify-center gap-x-1 rounded-lg border px-2 py-1 text-xs font-medium",
								copied ? "border-transparent bg-success-500 text-white" : "bg-white text-gray-600 hover:bg-gray-100",
							)}
						>

							{copied ? <CheckCircleIcon className="w-4"></CheckCircleIcon> :
								<ClipboardDocumentIcon className="w-4" />}
							<span> {copied? "In Zwischenablage kopiert" : "In Zwischenablage kopieren"}</span>

						</div>
					</button>
				</div>
			) : (
				<div className="break-words">{children}</div>
			)}
		</div>
	);
};

export default CardValue;